import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpService } from '../https.service';
import { Router } from '@angular/router';
import { Utils } from '../utils';
import * as $ from 'jquery';
import { URLUtils } from '../urlUtils';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent {

	role: any;
	submitted = false;
	firmsShow = true;
	firmsData: any = { firms: [] }
	showPassword = false;
	showMultiLogin: boolean = false;
	showResetForm: boolean = false;
	showLoginForm: boolean = true;
	showForgotForm: boolean = false;
	resetData: any = {};
	myForm: any = FormGroup;
	msg: string = ""
	isLoading: boolean = false;
	product = environment.product;

	constructor(private formBuilder: FormBuilder,
				private router: Router,
				private httpservice: HttpService) { }

	ngOnInit() {
		localStorage.removeItem("TOKEN")
		if (localStorage.getItem('alert_msg') != null) {
			this.msg = localStorage.getItem('alert_msg') as string
			localStorage.removeItem('alert_msg')
		} else if (localStorage.getItem('error_alert_msg') != null) {
			this.msg = localStorage.getItem('error_alert_msg') as string
			localStorage.removeItem('error_alert_msg')
		}
		this.myForm = this.formBuilder.group({
			email: ['', [Validators.required, Validators.pattern(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/)]],
			password: ['', Validators.required],
			plan: ['admin_console']
		})
	}

	get f() { return this.myForm.controls; }

	onSubmit() {
		this.submitted = true;
		this.msg = "";
		if (this.myForm.invalid) { return; }
		this.callLoginWebService(this.myForm.value)
	}

	callLoginWebService(data: any) {
		const email = this.myForm.value['email']?.trim().toLowerCase();
		localStorage.setItem('user_email', email);
		

		let payload = { ...data, email }

		this.isLoading = true;

		
		this.httpservice.sendRePostRequest(URLUtils.login, payload).subscribe(
			(resp: any) => {
				localStorage.setItem('TOKEN', resp['token'])
				
				this.isLoading = false;
				if (!resp['error']) {
					if (resp['data']?.['plan'] == Utils.productName) {
						this.initSession(resp)
					} else {
						this.msg = "Account not found"
					}
				} else {
					if (resp.hasOwnProperty("firms")) {
						const firms = Object.entries(resp['firms']?.[Utils.productName] ?? {})
						if (firms.length == 0) {
							this.msg = "Account not found"
						} else if (firms.length > 1) {
							this.firmsData['firms'] = resp['firms'][Utils.productName]
							this.firmsData['email'] = this.myForm.value['email']
						} else {
							const value = resp['firms'][Utils.productName][0]?.id;
							payload = { ...payload, userid: value };
							this.callLoginWebService(payload)
						}
					} else {
						// Always resolve to a clear user-visible message
						if (typeof resp?.msg === 'string' && resp.msg) {
							this.msg = resp.msg;
						} 
					}
				}
			},
			(error: any) => {
				// HTTP-level errors (network failure, 500, 401, etc.)
				this.isLoading = false;
				if (error?.error?.msg) {
					this.msg = error.error.msg;
				} 
			}
		)
	}

	initSession(resp: any) {
		if (resp['data']['password_mode'] != null) {
			if (resp['data']['password_mode'] == 'reset') {
				this.resetData = resp['data'];
				this.resetData['enteredPwd'] = this.myForm.value['password'];
				this.showResetForm = true;
				this.showLoginForm = false
				return
			}
		}
		if (resp['data']['plan'].toLowerCase() == Utils.productName) {
			localStorage.setItem('plan', resp['data']['plan'].toUpperCase())
		} else {
			this.msg = "Account not found"
			return
		}

		// API returns 'id' not 'user_id' — use 'id' as user_id
		const userId = resp['data']['id'] ?? resp['data']['user_id'];
		if (userId != null) {
			localStorage.setItem('user_id', userId)
		} else {
			localStorage.removeItem('user_id')
		}

		localStorage.setItem('TOKEN', resp['token'])
		localStorage.setItem('name', resp['data']['name'])
		localStorage.setItem('role',resp.data.role ?? resp.data.groups[0]);
  		localStorage.setItem('isadmin', resp['data']['admin'] ?? '')
		localStorage.setItem('jid', resp['data']['uid'] ?? '')
		localStorage.setItem('firm_name', resp['data']['firm_name'] ?? '')
		localStorage.setItem('profuid', resp['data']['profuid'] ?? '')
		const groups = resp['data']['groups'];
		localStorage.setItem('groups', Array.isArray(groups) ? groups.join(', ') : (groups ?? ''))
		
		// Store modules configuration from API response
		if (resp['data']['modules']) {
			localStorage.setItem('modules', JSON.stringify(resp['data']['modules']))
		}

		this.role = localStorage.getItem("role")

		if (this.role === 'AAM') {
			this.router.navigate(['groups'])
		}
		else if(this.role == 'Onboarding'){
			this.router.navigate(['/dashboard'])
		}
		 else {
			this.router.navigate(['/dashboard'])
		}
	}

	showFirmsList() {
		this.showLoginForm = false
		this.showMultiLogin = true
		this.showResetForm = false
	}

	forgotPwd() {
		this.showLoginForm = false
		this.showForgotForm = true
	}

	onChildEvent(msg: any) {
		if (msg["msg"] == 'firm-close') {
			this.showMultiLogin = false
			this.showResetForm = false
			this.showLoginForm = true
		}
		if (msg["msg"] == 'firm-done') { }
		if (msg["msg"] == 'resetpwd') {
			this.resetData = msg['data']
			this.showResetForm = true
			this.showMultiLogin = false
			this.showLoginForm = false
		}
		if (msg["msg"] == 'reset-success') {
			this.showLoginForm = true
			this.showResetForm = false
			this.showMultiLogin = false
			this.msg = "Password reset successfully! Please login"
		}
		if (msg['msg'] == 'forgot-success') {
			this.showLoginForm = true
			this.showForgotForm = false
			this.msg = "Password reset was successful"
		}
		if (msg['msg'] == 'forgot-cancel') {
			this.showLoginForm = true
			this.showForgotForm = false
		}
	}

	change_password_type() {
		this.showPassword = !this.showPassword
		const el = document.getElementById('toggle-password')
		if (el) {
			// remove all classes and add appropriate class without jQuery
			el.className = ''
			if (this.showPassword) el.classList.add('fa', 'fa-eye-slash', 'toggle-password')
			else el.classList.add('fa', 'fa-eye', 'toggle-password')
		}
	}
}